import React, {Component} from 'react';
import {connect} from "react-redux";
import PropTypes from 'prop-types';
import {Col, Input, Row, Tooltip} from "reactstrap";
import classnames from "classnames";

import {getCurrentMicroTime} from "../../../../../reducers/timeMeasuring/actions";
import {injectIntl} from "react-intl";
import RadioIcon from "../../Components/radioIcon";
import QuestionContainer from "../../Components/questionContainer";
import AnswerContainer from "../../Components/answerContainer";
import ImageOpenAnswer from "../../Components/imageOpenAnswer";

class PresentationCheckboxes extends Component {

  constructor(props) {
    super(props);
    this.state = {
      tooltipOpen: false
    };

    this.selectItem = this.selectItem.bind(this);
    this.onOpenChange = this.onOpenChange.bind(this);
    this.toggleTooltip = this.toggleTooltip.bind(this);
    this.isTooltipOpen = this.isTooltipOpen.bind(this);
    this.getContainerClasses = this.getContainerClasses.bind(this);
  }

  toggleTooltip(value) {
    if (this.state.tooltipOpen === value) {
      this.setState({tooltipOpen: false});
    }else{
      this.setState({tooltipOpen: value});
    }
  }

  isTooltipOpen(value) {
    return this.state.tooltipOpen === value;
  }

  selectItem(answer) {
    const detail = this.props.details.length > 0 ? this.props.details[0] : false;

    if((detail && detail.answer === answer)){
      return;
    }

    const microTime = getCurrentMicroTime(this.props.startTime);
    this.props.onDetailsUpdated([{
      answer,
      microTime
    }]);

    this.props.question.javascripts.map(javascript => {
      if(javascript.action === 'onAnswerSelected'){
        let func = new Function("return " + "function (answer) { " + javascript.code + " }")().bind(this);
        func(answer);
      }
    });
  }

  onOpenChange(e){
    const {question} = this.props;
    const detail = this.props.details[0];
    let value = e.target.value;

    if(value !== '' && !!question.openRegex){
      const regex = new RegExp(question.openRegex, 'g');
      if(!regex.test(value)){
        return;
      }
    }

    this.props.onDetailsUpdated([{
      answer: detail.answer,
      content: value,
    }]);
  }

  getContainerClasses() {
    const {question} = this.props;
    const forceCafeteryStyles = question.forceCafeteryStyles;
    let forceClasses = "";
    if (forceCafeteryStyles.answers && forceCafeteryStyles.answers.textAlign) {
      forceClasses += 'forceAlignCenter ';
    }

    return forceClasses;
  }

  render() {
    const {answers, details, answersColumns, answersImage, answerOpenAlwaysShow} = this.props;
    const detail = details.length > 0 ? details[0] : false;
    console.log(this.props)

    return (
        <QuestionContainer
            gridLine={false}
            answersColumns={answersColumns}
            component={<React.Fragment>
              {answers.map((answer) => {
                const checked = detail && parseInt(detail.answer) === answer.id;

                return <AnswerContainer
                    checked={checked}
                    answer={answer}
                    classes={this.getContainerClasses()}
                    onClick={(e) => {
                      if(e.target.tagName != 'INPUT'){
                        this.selectItem(answer.id)
                      }
                    }}
                    component={
                      <ImageOpenAnswer
                          answer={answer}
                          detail={detail}
                          checked={checked}
                          isTooltipOpen={this.isTooltipOpen(answer.id)}
                          toggleTooltip={() => this.toggleTooltip(answer.id)}
                          checkboxType={'radio'}
                          answersImage={answersImage}
                          showInput={(answer.isOpen && checked)}
                          showContent={(answer.isOpen && checked) === false}
                          onOpenChange={this.onOpenChange}
                          onBlur={this.onBlur}
                          answerOpenAlwaysShow={answerOpenAlwaysShow}
                      />
                    }
                />
              })}
            </React.Fragment>}
          />
    );
  }
}

PresentationCheckboxes.propTypes = {
  question: PropTypes.shape({
    javascripts: PropTypes.array.isRequired,
  }).isRequired,
  answers: PropTypes.array.isRequired,
  answersColumns: PropTypes.oneOf([1,2,3,4,6]).isRequired,
  answersImage: PropTypes.bool.isRequired,
  details: PropTypes.array.isRequired,
  onDetailsUpdated: PropTypes.func.isRequired,
};

export default connect((state) => {
  return {
    startTime: state.timeMeasuring.startTime,
  }
})(injectIntl(PresentationCheckboxes));